import { useMediaQuery } from "@mui/material";

export function useBreakpoints() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const isSmalldesktop = useMediaQuery("(max-width:1000px)");
  const semiSmalldesktop = useMediaQuery("(max-width:1370px)");
  const mediumDesktop = useMediaQuery("(max-width:1600px)");
  return { isMobile, isSmalldesktop, mediumDesktop, semiSmalldesktop };
}
